import React from 'react';

// Captura erros de runtime no render (ex.: crash que dava tela branca no Safari/iOS).
// Em vez de derrubar a SPA inteira, mostra uma tela com a mensagem do erro
// (para o cliente printar) e um botao de voltar funcional.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, info: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    this.setState({ info });
    // eslint-disable-next-line no-console
    console.error('[ErrorBoundary] crash capturado:', error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  handleHome = () => {
    window.location.href = '/imoveis';
  };

  render() {
    if (!this.state.hasError) return this.props.children;

    const { error, info } = this.state;
    const message = error?.message || String(error || 'Erro desconhecido');
    const stack = (error?.stack || '') + '\n' + (info?.componentStack || '');

    return (
      <div
        style={{
          minHeight: '100vh',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          padding: 24,
          fontFamily: '-apple-system, BlinkMacSystemFont, sans-serif',
          background: '#0F1828',
          color: '#F5F1E8',
          textAlign: 'center',
        }}
      >
        <h1 style={{ fontSize: 22, fontWeight: 600, margin: '0 0 12px' }}>
          Algo deu errado ao abrir esta pagina
        </h1>
        <p style={{ fontSize: 15, opacity: 0.7, margin: '0 0 24px', maxWidth: 420 }}>
          Tire um print desta tela e envie para o suporte. Os detalhes abaixo
          ajudam a corrigir o problema.
        </p>

        <div style={{ display: 'flex', gap: 12, marginBottom: 28, flexWrap: 'wrap', justifyContent: 'center' }}>
          <button
            type="button"
            onClick={this.handleHome}
            style={{
              padding: '12px 22px',
              borderRadius: 8,
              border: 'none',
              background: '#B8935A',
              color: '#0F1828',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Voltar aos imoveis
          </button>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              padding: '12px 22px',
              borderRadius: 8,
              border: '1px solid rgba(245,241,232,.3)',
              background: 'transparent',
              color: '#F5F1E8',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Recarregar
          </button>
        </div>

        <pre
          style={{
            maxWidth: '100%',
            width: 560,
            textAlign: 'left',
            fontSize: 12,
            lineHeight: 1.5,
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
            background: 'rgba(0,0,0,.35)',
            border: '1px solid rgba(184,147,90,.25)',
            borderRadius: 10,
            padding: 16,
            color: '#FFB4A0',
            overflow: 'auto',
            maxHeight: 260,
          }}
        >
          {message}
          {'\n\n'}
          {stack.trim()}
        </pre>
      </div>
    );
  }
}
